import React, {SyntheticEvent} from "react";
import {Alert, AlertColor, AlertTitle, IconButton, Snackbar, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";
import {ErrorMessage} from "~/components/ErrorHandling/AlertErrorHandlerProvider";
import {Close, Error as ErrorIcon, SuccessIcon} from "~/ui/icons";

const useStyles = makeStyles<PortTheme>(theme => ({
    errorIcon: {
        marginRight: 8,
        '& path': {
            fill: '#E53328'
        }
    },
    successIcon: {
        marginRight: 8,
    },
    alertTitle: {
        display: 'flex',
        alignItems: 'center',
    },
    message: {
        fontSize: 14,
    },
    root: {
        paddingBottom: 16
    }
}))

type PopupMessageProps = {
    onClose: (notification?: ErrorMessage,  e?: Event | SyntheticEvent<any, Event>) => void,
    open: boolean,
    notification: ErrorMessage,
    severity?: AlertColor
    autoHideDuration?: number
}
export const PopupMessage = (props: PopupMessageProps) => {
    const { onClose, open, notification, autoHideDuration, severity = 'error'} = props;
    const matches = useMediaQuery('(min-width:600px)');
    const styles = useStyles();

    return (
        <Snackbar
            open={open}
            onClose={(e) => onClose(notification, e)}
            anchorOrigin={{ vertical: 'bottom', horizontal: matches ? 'center' : 'left'}}
            autoHideDuration={autoHideDuration}
        >
            {notification && <Alert
                style={{width: "100%"}}
                severity={severity}
                icon={false}
                action={
                    <IconButton onClick={(e) => onClose(notification, e)} style={{marginTop: -8}}>
                        <Close style={{ fill: '#B6BBC5' }} />
                    </IconButton>
                }
            >
                {notification.title && <AlertTitle classes={{ root: styles.alertTitle }}>
                    {severity === 'error' &&  <ErrorIcon className={styles.errorIcon} />}
                    {severity === 'success' && <SuccessIcon className={styles.successIcon} />}
                    {notification.title}
                </AlertTitle>}
                {notification.message}
            </Alert>}
        </Snackbar>
    )
}
